export function getPublicPosthogKey(): string | undefined {
  return process.env.NEXT_PUBLIC_POSTHOG_KEY;
}
